import React from "react";
import { TextField, Grid, IconButton, Typography, Box } from "@mui/material";

import { Cancel as CancelIcon } from "@mui/icons-material";
import Provider from "../Provider";
import { useStyle } from "../styles";
import { ColorButton } from "../../../services/helper";

function FormThree() {
  const classes = useStyle();
  const {
    errorsFormOne,
    handleDateChange,
    handleFileChange,
    handleRemovePreview,
    formValues,
    previews,
    handleSubmitFormThree,
  } = Provider();

  return (
    <>
      <div className={classes.mainContainer}>
        <div className={classes.box}>
          <div className={classes.heading}>Add Car Documents</div>
          {/* License Document */}
          <Grid item xs={12}>
            <div style={{ margin: "2%" }}>
              <Typography variant="h6">License:</Typography>
              {previews?.license && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "2%",
                  }}
                >
                  <img
                    src={previews?.license}
                    alt="License Preview"
                    style={{ maxWidth: "50%", borderRadius: 10 }}
                  />
                  <IconButton onClick={() => handleRemovePreview("license")}>
                    <CancelIcon />
                  </IconButton>
                </Box>
              )}
              <input
                type="file"
                id="license"
                name="license"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              <label htmlFor="license">
                {!previews?.license && (
                  <ColorButton
                    variant="contained"
                    color="primary"
                    component="span"
                  >
                    Upload License
                  </ColorButton>
                )}
              </label>

              {errorsFormOne?.license && (
                <Typography color="error">{errorsFormOne?.license}</Typography>
              )}
            </div>
          </Grid>

          {/* Car Insurance Document */}
          <Grid item xs={12}>
            <div style={{ margin: "2%" }}>
              <Typography variant="h6">Car Insurance:</Typography>
              {previews?.carInsurance && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "2%",
                  }}
                >
                  <img
                    src={previews?.carInsurance}
                    alt="Car Insurance Preview"
                    style={{ maxWidth: "50%", borderRadius: 10 }}
                  />
                  <IconButton
                    onClick={() => handleRemovePreview("carInsurance")}
                  >
                    <CancelIcon />
                  </IconButton>
                </Box>
              )}
              <input
                type="file"
                id="carInsurance"
                name="carInsurance"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              <label htmlFor="carInsurance">
                {!previews?.carInsurance && (
                  <ColorButton
                    variant="contained"
                    color="primary"
                    component="span"
                  >
                    Upload Car Insurance
                  </ColorButton>
                )}
              </label>
              {errorsFormOne?.carInsurance && (
                <Typography color="error">
                  {errorsFormOne?.carInsurance}
                </Typography>
              )}
            </div>
          </Grid>

          {/* Car RC Document */}
          <Grid item xs={12}>
            <div style={{ margin: "2%" }}>
              <Typography variant="h6">Car RC:</Typography>
              {previews?.carRc && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "2%",
                  }}
                >
                  <img
                    src={previews?.carRc}
                    alt="Car RC Preview"
                    style={{ maxWidth: "50%", borderRadius: 10 }}
                  />
                  <IconButton onClick={() => handleRemovePreview("carRc")}>
                    <CancelIcon />
                  </IconButton>
                </Box>
              )}
              <input
                type="file"
                id="carRc"
                name="carRc"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              <label htmlFor="carRc">
                {!previews?.carRc && (
                  <ColorButton
                    variant="contained"
                    color="primary"
                    component="span"
                  >
                    Upload Car RC
                  </ColorButton>
                )}
              </label>
              {errorsFormOne?.carRc && (
                <Typography color="error">{errorsFormOne?.carRc}</Typography>
              )}
            </div>
          </Grid>

          {/* Expiry Date */}
          <Grid item xs={12}>
            <div style={{ margin: "2%" }}>
              <TextField
                fullWidth
                id="insuranceExpiryDate"
                name="insuranceExpiryDate"
                label="Insurance Expiry Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={formValues?.insuranceExpiryDate}
                onChange={handleDateChange}
                error={Boolean(errorsFormOne?.insuranceExpiryDate)}
                helperText={errorsFormOne?.insuranceExpiryDate}
              />
            </div>
          </Grid>

          <Grid item xs={12}>
            <ColorButton onClick={handleSubmitFormThree} variant="contained">
              Next
            </ColorButton>
          </Grid>
        </div>
      </div>
    </>
  );
}

export default FormThree;
